import { useContext, useEffect, useRef, useState } from "react";
import { AppDB } from "../../../App";
import { votersService } from "../../../services/VotersService";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import AddCandidateComponet from "./AddCandidateComponet";
import { Steps } from 'primereact/steps';
import { Dropdown } from "primereact/dropdown";
import PoliticalPartyService from "../../../services/PoliticalPartyService";
import DocumentTypesService from "../../../services/DocumentsService";
import { InputTextarea } from "primereact/inputtextarea";
import { Image } from "primereact/image";
import { InputNumber } from "primereact/inputnumber";
import { candidateService } from "../../../services/CandidateService";
import GenericFileCapture from "../../../componets/GenericFileCapture";
import GenericUploadFileTable from "../../../componets/GenericUploadFileTable";
import { helper } from "../../../componets/utils/helper";
import { Calendar } from "primereact/calendar";
import TimeComponent from "../../../componets/TimeComponent";



export default function ({ isNational = true, delimitation, refresh, setRefresh, showCandidateDialog = {}, setShowCandidateDialog = () => { }, label = "Search Elector", onUpdate = () => { } }) {

    var { toast, lookUp } = useContext(AppDB)
    var [showFileUploader, setShowFileUploader] = useState(false);
    var [fileUploaderDocuments, setFileUploaderDocuments] = useState([])
    var [loading, setLoading] = useState(false);
    var [politicalPartyList, setPoliticalPartyList] = useState([]);
    var [candidateDocumentTypes, setCandidateDocuments] = useState([]);

    var [requireForm, setRequireForm] = useState({
        ballotOtherName: "",
        "candidateOrder": 1,   //input
        "ballotName": "",
        "photo": "",
        "logo": "",
        "candidateTypeID": "",
        politicalPartyID: "",
        emailAddress: "",
        address: "",
        candidateNominationForm: "",
        nominationDate: "",
        candidateNominationForm: ""

    })
    var raw_form = {
        "eventID": showCandidateDialog?.event?.eventID,
        "voterID": null,
        "time": null,
        "candidateTypeID": null,
        "proposerID": null,
        "seconderID": null,
        "politicalPartyID": null,
        "delimitationID": showCandidateDialog?.delimitationID,
        "delimitationLevelID": showCandidateDialog?.delimitationLevelID,
        "nominationDate": "",
        "candidateOrder": '1',   //input
        "ballotOtherName": "",
        "ballotName": "",
        "contactNumber": "",
        "address": "",
        "logo": "",
        "logoExtension": "",
        "logoContentType": "",
        "photo": "",
        "photoExtension": "",
        "photoExtension": "",
        "emailAddress": "",
        documents: []
    }
    var [form, setForm] = useState(raw_form)
    var [sameVillage, setSameVillage] = useState({
        "voter": "",
        "proposer": "",
        "seconder": "",
    })


    useEffect(() => {
        setForm(raw_form)
    }, [showCandidateDialog])

    const faceFileRef = useRef(null);
    const onBtnClickFace = () => {
        faceFileRef.current.value = "";
        faceFileRef.current.click();
    };
    const inputFileRef = useRef(null);
    const onBtnClick = () => {
        inputFileRef.current.value = "";
        inputFileRef.current.click();
    };

    var convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

    async function onUploadHandler(e, name) {
        const file = e.files[0];
        const base64 = await convertBase64(file);
        var base64result = base64;
        const extension = file.name.split(".").pop();
        setForm({ ...form, [name]: base64result, [`${name}Extension`]: extension, [`${name}ContentType`]: file.type });
    }


    const [activeIndex, setActiveIndex] = useState(0);
    const items = [
        {
            label: 'Candidate/Proposer/Seconder'
        },
        {
            label: 'Other Info'
        }
    ];
    var political = new PoliticalPartyService();
    var documentService = new DocumentTypesService();
    useEffect(() => {
        political.getAllPoliticalParties().then(res => {
            //get active political parties only
            const filtered = res.politicalParties.filter(
                party => party.politicalPartyStatusID === 1
            );
            setPoliticalPartyList(filtered);
        });

        documentService.getDocumentTypes(5).then(res => {
            setCandidateDocuments(res)
        })

    }, [])

    useEffect(() => {
        if (helper.hasDuplicates([form.proposerID, form.seconderID, form.voterID])) {
            toast.show({
                severity: "error",
                detail: ' Elector, Proposer, and Seconder must have different ID numbers.',
                life: 6500
            })
        }
    }, [form])


    function handleYesOrNo(answer) {
        if (answer === 'Yes') {
            setShowCandidateDialog({ ...showCandidateDialog, show: false });
            setActiveIndex(0);
            toast.clear();
        } else {
            toast.clear(); // Clear the toast if 'No' is clicked
            return; // Exit the function to prevent further actions
        }
    }


    function onDocumentChange(_documents = []) {
        requireForm.candidateNominationForm = "";
        if (_documents.length === 0) {
            requireForm.candidateNominationForm = "Documents are required"
        }
        if (_documents.length > 0) {
            if (!fileUploaderDocuments.find(doc => doc.documentTypeID == 19)) {
                requireForm.candidateNominationForm = "Candidate Nomination Form is required"
            }
            if (!_documents.find(doc => doc.documentTypeID == 20)) {
                requireForm.candidateNominationForm = "Consent Form is required"
            }
            if (!_documents.find(doc => doc.documentTypeID == 22)) {
                requireForm.candidateNominationForm = " Nomination Fee Receipt is required"
            }
        }

        const allEmpty = Object.values(requireForm).every(value => value === "");
        if (!allEmpty) {
            setRequireForm({ ...requireForm });
            return;
        } else {
            setRequireForm({ ...requireForm });
        }

    }

    function showConfirmToast() {
        toast.show({
            severity: 'warn',
            summary: 'Are you sure?',
            content: (
                <div className="p-3">
                    <p className="mb-3">
                        Warning: Clicking 'Close' will discard all changes. Are you sure you want to discard changes and close?
                    </p>
                    <div className="flex justify-end gap-2">
                        <button
                            className="p-button p-button-sm"
                            onClick={() => handleYesOrNo('Yes')}
                        >
                            Yes
                        </button>
                        <button
                            className="p-button p-button-sm p-button-secondary"
                            onClick={() => handleYesOrNo('No')}
                        >
                            No
                        </button>
                    </div>
                </div>
            ),
            closable: false,
            life: 10000
        });
    }
    function onAddCandidate() {
        requireForm.ballotName = ""
        requireForm.ballotOtherName = ""
        requireForm.candidateOrder = ""
        requireForm.candidateTypeID = ""
        requireForm.politicalPartyID = ""
        requireForm.logo = ""
        requireForm.photo = ""
        requireForm.politicalPartyID = ""
        requireForm.address = ""
        if (form.address.trim().length === 0) {
            requireForm.address = "required"
        }

        if ([null, undefined, ""].includes(form.ballotName)) {
            requireForm.ballotName = "required"
        }
        if ([null, undefined, ""].includes(form.candidateOrder)) {
            requireForm.candidateOrder = "required"
        }
        if (form.candidateTypeID === null) {
            requireForm.candidateTypeID = "required"
        }

        if (form.politicalPartyID === null && form.candidateTypeID == 2) {
            requireForm.politicalPartyID = "required"
        }
        if ([null, undefined, ""].includes(form.nominationDate)) {
            requireForm.nominationDate = "required"
        }
        if ([null, undefined, ""].includes(form.ballotOtherName)) {
            requireForm.ballotOtherName = "required"
        }


        // if (form.logo.trim().length === 0) {
        //     requireForm.logo = "required"
        // }

        if (form.photo.trim().length === 0) {
            requireForm.photo = "required"
        }

        if (fileUploaderDocuments.length === 0) {
            requireForm.candidateNominationForm = "Documents are is required"
        }




        const allEmpty = Object.values(requireForm).every(value => value === "");
        if (!allEmpty) {
            setRequireForm({ ...requireForm });
            return;
        } else {
            setRequireForm({ ...requireForm });
        }

        var clone = { ...JSON.parse(JSON.stringify(form)), documents: fileUploaderDocuments };

        var cloneImageLogo = clone?.logo?.split(",");
        if (cloneImageLogo?.length >= 2) {
            clone.logo = cloneImageLogo[1];
        }
        var cloneImagePhoto = clone?.photo?.split(",");
        if (cloneImagePhoto?.length >= 2) {
            clone.photo = cloneImagePhoto[1];
        }

        clone.documents = clone.documents.map(doc => {
            var d = doc?.binaryData?.split(",");
            if (d?.length >= 2) {
                doc.binaryData = d[1];
            }
            return doc
        })
        setLoading(true)
        let nominationDate = null;
        if (form?.nominationDate && form?.time) {
            const dateObj = new Date(form.nominationDate);

            if (!isNaN(dateObj.getTime())) {
                const datePart = dateObj.toISOString().split("T")[0];
                nominationDate = `${datePart}T${form.time}`;
            }
            clone.nominationDate = nominationDate;
        }

        candidateService.create(clone).then(res => {
            setLoading(false);
            if (res.success) {
                setActiveIndex(0)
                setShowCandidateDialog({ ...showCandidateDialog, show: false })
                setRefresh(!refresh)
                setFileUploaderDocuments([])
                toast.show({
                    severity: "success",
                    detail: "Candidate Created",
                    life: 2500
                });
            } else {

                toast.show({
                    severity: "error",
                    detail: res.message,
                    life: 2500
                })
            }


        })
    }



    return (<>
        <Dialog
            onHide={e => {
                setShowCandidateDialog({ ...showCandidateDialog, show: false })
                setActiveIndex(0)
            }}
            maximized
            header={
                <>
                    <h5 className="my-0">Add Candidate</h5>
                    {/* {helper.hasDuplicates([form.proposerID, form.seconderID, form.voterID]) && (<div style={{ color: "red", fontSize: 12, fontWeight: "normal" }}>
                        Elector, Proposer, and Seconder must have different ID numbers.
                    </div>)} */}

                </>
            } style={{ width: "100%", maxWidth: "900px", height: "100vh" }} visible={showCandidateDialog.show}
            footer={<>



                {activeIndex === 0 && <Button label="Next"
                    disabled={form.voterID === null || form.seconderID === null || form.proposerID === null || sameVillage.proposer !== "" || sameVillage.seconder !== ""}
                    onClick={() => {
                        if (helper.hasDuplicates([form.proposerID, form.seconderID, form.voterID])) {
                            toast.show({
                                severity: "error",
                                detail: ' Elector, Proposer, and Seconder must have different ID numbers.',
                                life: 6500
                            })
                            return;
                        }
                        setActiveIndex(1)
                    }

                    } />}


                {activeIndex === 1 && <>
                    <Button label="Back" onClick={() => setActiveIndex(0)} />
                    <Button loading={loading} label="Submit" onClick={() => { onAddCandidate() }} />
                </>}
                <Button className="p-button-danger" loading={loading} label="Close" onClick={() => {
                    showConfirmToast();
                }} />


            </>}
        >
            <Steps className="my-2" activeIndex={activeIndex} onSelect={(e) => setActiveIndex(e.index)} readOnly model={items} />



            <div style={{ display: activeIndex === 0 ? "none" : "block" }}>
                <div className="grid"  >

                    <div className="col-12 md:col-6">
                        <label><b> Nomination Date</b> <span className='required-input'>*</span></label>
                        <Calendar maxDate={new Date(localStorage.getItem("central-site-date"))} hideOnDateTimeSelect className="w-full" value={form.nominationDate} onChange={(e) => {
                            setForm({ ...form, nominationDate: e.target.value })
                            setRequireForm({ ...requireForm, nominationDate: "" })
                        }} />
                        <span className='required-input'>{requireForm.nominationDate}</span>
                    </div>
                    <div className="col-12 md:col-3">
                        <label><b> Nomination Time</b> <span className='required-input'>*</span></label>
                        <TimeComponent onChange={time => {
                            setForm({ ...form, time: time })
                        }} />
                        {/* <span className='required-input'>{requireForm.nominationDate}</span> */}
                    </div>
                    {/* TimeComponent */}

                    <div className="col-12 md:col-4">
                        <label><b>Candidate Type<span className='required-input'>*</span></b></label>
                        <Dropdown className="w-full" value={form.candidateTypeID} onChange={e => {
                            var obj = {};
                            var __politicalPartyID = ""
                            if (e.value === 1) {
                                obj = {
                                    "logo": '',
                                    "logoExtension": '',
                                    "logoContentType": '',
                                    "photo": "",
                                    "photoExtension": "",
                                    "photoContentType": "",
                                }
                            } else {
                                __politicalPartyID = "required"
                            }

                            setForm({ ...form, candidateTypeID: e.value, politicalPartyID: null, ...obj })
                            setRequireForm({ ...requireForm, candidateTypeID: "", politicalPartyID: __politicalPartyID })
                        }
                        } optionLabel="name" optionValue="id" options={lookUp.candidateTypes} />
                        <span className='required-input'>{requireForm.candidateTypeID}</span>
                    </div>



                    {form.candidateTypeID === 2 && (<div className="col-12 md:col-4">
                        <label><b>Political Party</b><span className='required-input'>*</span></label>
                        <Dropdown className="w-full"
                            value={form.politicalPartyID} onChange={e => {

                                var obj = {};
                                var partyInfo = politicalPartyList.find((party) => party.politicalPartyID === e.value)

                                obj = {
                                    "logo": partyInfo.logo,
                                    "logoExtension": partyInfo.logoExtension,
                                    "logoContentType": partyInfo.logoContentType,
                                }

                                setForm({ ...form, politicalPartyID: e.value, ...obj })
                                setRequireForm({ ...requireForm, politicalPartyID: "", logo: '' })
                            }}
                            optionLabel="name" optionValue="politicalPartyID" options={politicalPartyList} />
                        <span className='required-input'>{requireForm.politicalPartyID}</span>
                    </div>)}


                    <>
                        <div className="col-12 md:col-4">
                            <label><b>Ballot Name</b><span className='required-input'>*</span></label>
                            <InputText className="w-full" value={form.ballotName} onChange={e => {
                                setForm({ ...form, ballotName: e.target.value })

                                if (e.target.value.toString().trim().length === 0) {
                                    setRequireForm({ ...requireForm, ballotName: "required" })
                                    return
                                }
                                setRequireForm({ ...requireForm, ballotName: "" })

                            }
                            } optionLabel="name" optionValue="id" options={lookUp.candidateTypes} />
                            <span className='required-input'>{requireForm.ballotName}</span>
                        </div>
                    </>


                    <>
                        <div className="col-12 md:col-4">
                            <label><b>Ballot Other Name</b><span className='required-input'>*</span></label>
                            <InputText className="w-full" value={form.ballotOtherName} onChange={e => {
                                setForm({ ...form, ballotOtherName: e.target.value })

                                if (e.target.value.toString().trim().length === 0) {
                                    setRequireForm({ ...requireForm, ballotOtherName: "required" })
                                    return
                                }
                                setRequireForm({ ...requireForm, ballotOtherName: "" })

                            }
                            } optionLabel="name" optionValue="id" options={lookUp.candidateTypes} />
                            <span className='required-input'>{requireForm.ballotOtherName}</span>
                        </div>
                    </>


                    <div className="col-12  lg:col-3">
                        <label htmlFor="description">
                            <b>Candidate Photo</b> <span className='required-input'>*</span>
                        </label>
                        <>
                            <Button
                                // style={{ display: !checked ? "none" : "block" }}

                                label={form?.photo?.trim().length === 0 ? "Select a file" : "Photo Added"}
                                onClick={onBtnClickFace}
                                className="p-button-success w-full"
                                icon={form?.photo?.trim().length === 0 ? "pi pi-plus" : ""}
                            />
                            <input
                                ref={faceFileRef}
                                type={"file"}
                                onChange={(e) => {
                                    onUploadHandler(e.target, 'photo')
                                    setRequireForm({ ...requireForm, photo: "" })
                                }}
                                style={{ display: "none" }}
                                accept="image/*"
                            ></input>
                        </>
                        <small style={{ width: "100%" }} className="p-error">
                            {/* {formErrorMessage.logo} */}
                        </small>
                        <div style={{ visibility: "hidden" }}>LOGO</div>
                        {form?.photo?.trim().length === 0 ? (
                            ""
                        ) : (
                            <Image
                                preview={true}
                                src={`${form.photo}`}
                                alt="Logo"
                                width="100px"
                                style={{ width: "100px", objectFit: "cover" }}
                            />
                        )}
                        <span className='required-input'>{requireForm.photo}</span>
                    </div>
                    {form.candidateTypeID !== 2 && (<>
                        <div className="col-12  lg:col-3">
                            <label htmlFor="description">
                                <b>Logo/Symbol</b> <span className='required-input'>*</span>
                            </label>
                            <>
                                <Button
                                    // style={{ display: !checked ? "none" : "block" }}

                                    label={form?.logo?.trim().length === 0 ? "Select a file" : "Logo Added"}
                                    onClick={onBtnClick}
                                    className="p-button-success w-full"
                                    icon={form?.logo?.trim().length === 0 ? "pi pi-plus" : ""}
                                />
                                <input
                                    ref={inputFileRef}
                                    type={"file"}
                                    onChange={(e) => {
                                        onUploadHandler(e.target, "logo")
                                        setRequireForm({ ...requireForm, logo: "" })
                                    }}
                                    style={{ display: "none" }}
                                    accept="image/*"
                                ></input>
                            </>
                            <small style={{ width: "100%" }} className="p-error">
                                {/* {formErrorMessage.logo} */}
                            </small>
                            <div style={{ visibility: "hidden" }}>LOGO</div>
                            {form?.logo?.trim().length === 0 ? (
                                ""
                            ) : (
                                <Image
                                    preview={true}
                                    src={`${form.logo}`}
                                    alt="Logo"
                                    width="100px"
                                    style={{ width: "100px", objectFit: "cover" }}
                                />
                            )}
                            <span className='required-input'>{requireForm.logo}</span>
                        </div>
                    </>)}


                    <div className="col-12 md:col-12">
                        <label><b>Email Address</b></label>
                        <InputText className="w-full" value={form.emailAddress} onChange={e => {
                            setForm({ ...form, emailAddress: e.target.value })
                            // if (e.target.value.trim().length === 0) {
                            //     setRequireForm({ ...requireForm, emailAddress: "required" })
                            //     return
                            // }
                            // setRequireForm({ ...requireForm, emailAddress: "" })
                        }} optionLabel="name" optionValue="id" options={lookUp.candidateTypes} />
                        <span className='required-input'>{requireForm.emailAddress}</span>
                    </div>
                    <div className="col-12 md:col-12">
                        <label><b>Address</b> <span className='required-input'>*</span></label>
                        <InputTextarea className="w-full" value={form.address} onChange={e => {
                            setForm({ ...form, address: e.target.value })
                            if (e.target.value.trim().length === 0) {
                                setRequireForm({ ...requireForm, address: "required" })
                                return
                            }
                            setRequireForm({ ...requireForm, address: "" })
                        }} optionLabel="name" optionValue="id" options={lookUp.candidateTypes} />
                        <span className='required-input'>{requireForm.address}</span>
                    </div>



                    <div className="col-12">
                        <GenericFileCapture
                            dontClearDocuments={true}
                            onDocumentChange={onDocumentChange}
                            refresh={refresh} setRefresh={setRefresh}
                            key={JSON.stringify(form)}
                            extraAttributes={{
                                // "candidateID": selectedCanditate.candidateID,
                                "eventID": showCandidateDialog?.event?.eventID
                            }}
                            documentTypesLookUp={candidateDocumentTypes} show={showFileUploader} setShow={setShowFileUploader}
                            setDocuments={setFileUploaderDocuments}
                            documents={fileUploaderDocuments}
                        />
                        <GenericUploadFileTable
                            header={<div className="col-12  lg:col-3 my-2">
                                <label htmlFor="description" className="required-input-asterisk">
                                    Upload Documents
                                </label>
                                <br />
                                <>
                                    <Button
                                        label={"Upload"}
                                        onClick={() => setShowFileUploader(true)}
                                        className="p-button-success"
                                        icon={"pi pi-plus"}
                                    />
                                    <br />
                                    <span style={{ color: "red", fontWeight: 500 }}>{requireForm.candidateNominationForm}</span>
                                </>
                            </div>}
                            setDocuments={setFileUploaderDocuments}
                            documents={fileUploaderDocuments}
                        />
                    </div>

                </div>
            </div>

            <AddCandidateComponet
                isCandidate={false}
                isNational={isNational}
                delimitationID={showCandidateDialog?.delimitationID}
                error={""}
                name="Candidate"
                onUpdate={(voterID, ballotName, village, _, name, surname) => {
                    console.log(voterID, ballotName, village, _, name, surname)
                    if (isNational) {
                        setSameVillage({ ...sameVillage, level: village?.constituencyID, proposer: "", seconder: "" })
                    } else {
                        setSameVillage({ ...sameVillage, level: village?.councilID, proposer: "", seconder: "" })
                    }
                    setForm({ ...form, voterID: voterID, ballotName: surname, ballotOtherName: name, seconderID: null, proposerID: null })
                }}
                show={activeIndex === 0} label="Search Candidate" />
            <b>

            </b>
            {form.voterID !== null && (<>
                <AddCandidateComponet
                    info={showCandidateDialog}
                    isCandidate={true}
                    isNational={isNational}
                    name="Proposer"
                    delimitationID={showCandidateDialog?.delimitationID}
                    error={sameVillage.proposer}
                    onUpdate={(proposerID, _, village) => {
                        // if (isNational) {
                        //     if (village?.constituencyID !== sameVillage.level) {
                        //         setSameVillage({ ...sameVillage, proposer: "Proposer must be in the same constituency as candidate" })
                        //     } else {
                        //         setSameVillage({ ...sameVillage, proposer: "" })
                        //     }
                        // } else {
                        //     if (village?.councilID !== sameVillage.level) {
                        //         setSameVillage({ ...sameVillage, proposer: "Proposer must be in the same Council as candidate" })
                        //     } else {
                        //         setSameVillage({ ...sameVillage, proposer: "" })
                        //     }
                        // }
                        setForm({ ...form, proposerID: proposerID })
                    }}
                    show={activeIndex === 0} label="Search Proposer" />
            </>)}
            {form.proposerID !== null && (<>
                <AddCandidateComponet
                    isCandidate={true}
                    info={showCandidateDialog}
                    isNational={isNational}
                    error={sameVillage.seconder}
                    name="Seconder"
                    delimitationID={showCandidateDialog?.delimitationID}
                    onUpdate={(seconderID, _, village) => {
                        // if (isNational) {
                        //     if (village?.constituencyID !== sameVillage.level) {
                        //         setSameVillage({ ...sameVillage, seconder: "Seconder must be in the same constituency as candidate" })
                        //     } else {
                        //         setSameVillage({ ...sameVillage, seconder: "" })
                        //     }
                        // } else {
                        //     if (village?.councilID !== sameVillage.level) {
                        //         setSameVillage({ ...sameVillage, seconder: "Seconder must be in the same Council as candidate" })
                        //     } else {
                        //         setSameVillage({ ...sameVillage, seconder: "" })
                        //     }
                        // }
                        setForm({ ...form, seconderID: seconderID })
                    }}
                    show={activeIndex === 0} label="Search  Seconder" />
            </>)}



        </Dialog>
    </>)
}